export default __webpack_public_path__ + "dd89563360f0272635c8f0ab7d7f1402.png";